import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LeadData, LeadDataObject, LeadsData } from '../../../../models/leads/leads.model';
import { DateTimeHelper } from '../../../../helper/date-time.helper';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import { LOCALE_KEY } from '../../../../services/user-service/user-token.service';
import { LeadHelper } from '../../../../helper/lead.helper';

@Component({
  selector: 'fi-lead-status',
  templateUrl: './lead-status.component.html',
  styleUrls: ['./lead-status.component.scss'],
  standalone: false,
})
export class LeadStatusComponent implements OnInit, OnChanges {
  private static currentDate: Date;

  @Input() leadData: LeadData | LeadsData;
  @Input() showStatusLabel: boolean;
  @Input() isOverview: boolean;
  @Input() compactView: boolean;
  @Input() printView: boolean;
  @Input() dense: boolean;
  @Input() unread: boolean;
  @Input() moveIndicatorToEnd: boolean;

  isDone = false;
  remainingTime = '';
  colorClassName = '';
  statusText = '';

  private readonly leadTypeRelationshipManagement = LeadHelper.LEAD_TYPE_PLANER_RELATIONSHIP;

  constructor( @Inject(LEADS_DATA_SERVICE) private leadDataService: LeadsDataService ) {
    LeadStatusComponent.currentDate = new Date();
  }

  ngOnInit(): void {
    this.refreshData();
  }

  ngOnChanges(): void {
    this.refreshData();
  }

  private refreshData(): void {
    const lead = this.leadData?.Lead;
    const leadType = lead?.LeadTypeId;
    this.isDone = !!lead?.Done;


    if ( leadType === this.leadTypeRelationshipManagement && !this.isDone && !lead?.Deadline && !lead?.DoneDate) {
      this.showStatusLabel = false;
      this.statusText = '';
      this.remainingTime = 'Ongoing';
      this.colorClassName = 'green-color';
      return;
    }

    const deadlineDate = lead?.Deadline;
    const doneDate = lead?.DoneDate;
    if ( doneDate ) {
      this.remainingTime = DateTimeHelper.getFormattedDate(doneDate as string).split('-')[0];
    } else {
      this.remainingTime = DateTimeHelper.getRelativeTime(deadlineDate, sessionStorage.getItem(LOCALE_KEY));
    }

    if ( !lead?.Deadline ) {
      this.colorClassName = '';
    } else {
      let date = new Date(this.leadData?.Lead?.Deadline);
      const diff = date.getTime() - LeadStatusComponent.currentDate.getTime();
      const hours = diff / (60 * 60 * 1000);

      if ( hours <= 0 ) {
        this.colorClassName = 'red-color';
      } else if ( hours < 24 ) {
        this.colorClassName = 'orange-color';
      } else {
        this.colorClassName = 'green-color';
      }
    }

    this.statusText = lead?.StatusText || '';
  }
}
